import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { buildTheme } from '@/theme/muiTheme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The questionnaire changes only with a new version, and the stand has one customer at a
      // time. Aggressive refetching would cost network on a flaky connection for no benefit.
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Built once. The theme no longer depends on anything that changes at runtime — the TDC brand
// theme is light only — so rebuilding it on every render would just throw work away.
const theme = buildTheme();

export function Root() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
